import React from "react";
import { SvgProps } from ".";

export const PhoneSvg: React.FC<SvgProps> = ({ fill }) => {
  return (
    <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1">
      <title>Phone</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group" data-testid="PhoneLogo">
          <rect id="Rectangle" x="0" y="0" width="40" height="40" />
          <path
            d="M14.4494203,19.5023875 C15.7460388,22.1532258 17.8947893,24.2922134 20.5515047,25.5767469 C20.9469702,25.7641451 21.4119705,25.7289637 21.7747391,25.4841984 L25.6865625,22.8757078 C26.0380493,22.6413294 26.4841407,22.6003488 26.8724469,22.7667656 L34.1907281,25.9031719 C34.7014453,26.1201134 35.0071304,26.6486666 34.9404688,27.1995312 C34.4619188,30.9441835 31.2751067,33.75 27.5,33.75 C15.7639491,33.75 6.25,24.2360509 6.25,12.5 C6.25,8.72489327 9.05581646,5.53808123 12.8004688,5.05953125 C13.351328,4.99286841 13.8798781,5.29854551 14.096825,5.80925469 L17.2359672,13.1339219 C17.4008827,13.518725 17.3622102,13.9605371 17.13295,14.3108375 L14.5335141,18.2826703 C14.2928425,18.6461316 14.2609067,19.1093359 14.4494203,19.5023875 Z"
            id="Path"
            stroke={fill || "#252525"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default {};
